import axios from 'axios';
import cfg from '@/config';

function request(url, options) {
    const method = (options.method || 'get').toLowerCase();
    const opts = {
        url,
        method,
        baseURL: options.baseUrl || cfg.BASE_URL_PREFIX
    };
    let data = options.data || {};
    method === 'get' ? (opts.params = data) : (opts.data = data);
    return axios(opts).then(({status, statusText, data}) => {
        return data;
    }).catch((err) => {
        console.log(err.message);
    })
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js